import { createContext, useContext, useMemo } from 'react';

/**
 * Drawer / machine-hosted select-job flow. When `apmFlowState` is set, it
 * overrides history.location.state for APM branches (merge, start-jobs, split).
 *
 * @typedef {Object} SelectJobFlowContextValue
 * @property {object|null} apmFlowState - flags: eventId, isChangeJob, isSplitChangeJob
 * @property {object|null} splitJobContext - payload for split-change-job (replaces sessionStorage in drawer)
 * @property {() => void} [onApmFlowComplete] - close drawer / finish flow without navigating away
 */

const SelectJobFlowContext = createContext(null);

export const SelectJobFlowProvider = SelectJobFlowContext.Provider;

export function useSelectJobFlowContext() {
  return useContext(SelectJobFlowContext);
}

/**
 * Merge React Router location.state with optional drawer flow state.
 */
export function useEffectiveSelectJobRouteState(historyState) {
  const ctx = useSelectJobFlowContext();
  return useMemo(() => {
    const base = historyState || {};
    if (ctx?.apmFlowState != null) {
      return { ...base, ...ctx.apmFlowState };
    }
    return base;
  }, [ctx, historyState]);
}
